"use client";

export function ChevronRightRedIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
                d="M5.03033 2.46967C4.73744 2.17678 4.26268 2.17678 3.96978 2.46967C3.67689 2.76256 3.67689 3.23732 3.96978 3.53022L6.43951 5.99994L3.96978 8.46967C3.67689 8.76256 3.67689 9.23732 3.96978 9.53022C4.26268 9.82311 4.73744 9.82311 5.03033 9.53022L8.03033 6.53022C8.32322 6.23732 8.32322 5.76256 8.03033 5.46967L5.03033 2.46967Z"
                fill="currentColor"
            />
        </svg>
    );
}
